import type { ReactNode } from "react";
import type { LucideIcon } from "lucide-react";

import {
  PROJECT_STEP_GENERATE_COPY,
  type ProjectStepId,
  type StepGenerateCopy,
} from "config/navigation";
import { StepEmptyState, type StepEmptyStateProps } from "./StepEmptyState";
import type { StepGeneration } from "./useStepGeneration";

interface StepGenerateEmptyStateProps {
  stepId: ProjectStepId;
  /** From `useStepGeneration`, which the page also uses to decide to show this. */
  generation: StepGeneration;
  /** The page's own icon, e.g. the stripboard grid. */
  icon: LucideIcon;
  /** Overrides the step's copy, e.g. for Coverage. */
  copy?: StepGenerateCopy;
  secondaryAction?: ReactNode;
  variant?: StepEmptyStateProps["variant"];
  className?: string;
}

/** A step page's "not generated" state with the step's copy and Generate button. */
export const StepGenerateEmptyState = ({
  stepId,
  generation,
  icon,
  copy = PROJECT_STEP_GENERATE_COPY[stepId],
  secondaryAction,
  variant,
  className,
}: StepGenerateEmptyStateProps) => (
  <StepEmptyState
    icon={icon}
    title={copy.title}
    description={copy.description}
    actionLabel={copy.actionLabel}
    onGenerate={generation.generate}
    secondaryAction={secondaryAction}
    variant={variant}
    className={className}
  />
);
